export enum ProductAvailability {
	OutOfStock = "OutOfStock",
	PreOrder = "PreOrder",
	InStock = "InStock",
}
